export const DB_NAME = 'agro-online'

export const DB_VERSION = 1

export const CACHE_STORAGE_OPTIONS = {
	WITHOUT_CHANGES: 'without_changes',
	WITH_SPLITTING: 'with_splitting',
}

export const STORE_MAP = {
	VERSION: 'version',
	SIMPLE: 'simple_storage',
	BASE: 'level_base',
	EXTENDED: 'level_extended',
	FULL: 'level_full',
}

export const STORES_SCHEMA = {
	[STORE_MAP.VERSION]: {
		KEY: 'key',
		DATA: 'data',
	},
	[STORE_MAP.SIMPLE]: {
		KEY: 'key',
		DATA: 'data',
	},
	[STORE_MAP.BASE]: {
		KEY: 'key',
		DATA: 'data',
	},
	[STORE_MAP.EXTENDED]: {
		KEY: 'key',
		DATA: 'data',
	},
	[STORE_MAP.FULL]: {
		KEY: 'key',
		DATA: 'data',
	},
}

export const STORES_METHODS_MAP = {
	[STORE_MAP.VERSION]: {
		GET: 'getVersion',
		SET: 'setVersion',
	},
	[STORE_MAP.SIMPLE]: {
		GET: 'getFromSimple',
		SET: 'setToSimple',
	},
	[STORE_MAP.BASE]: {
		GET: 'getFromLevelBase',
		SET: 'setToLevelBase',
	},
	[STORE_MAP.EXTENDED]: {
		GET: 'getFromLevelExtended',
		SET: 'setToLevelExtended',
	},
	[STORE_MAP.FULL]: {
		GET: 'getFromLevelFull',
		SET: 'setToLevelFull',
	},
}
